import React, { useEffect, Children } from 'react';
import { Star, Quote } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
export function Testimonials() {
  const {
    t
  } = useLanguage();
  const controls = useAnimation();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  useEffect(() => {
    if (inView) {
      controls.start('visible');
    }
  }, [controls, inView]);
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 40
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="py-24 bg-white" data-id="element-215">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-216">
        <div className="text-center mb-16" data-id="element-217">
          <h2 className="text-3xl md:text-4xl font-heading font-extrabold text-brand-black mb-4" data-id="element-218">
            {t.testimonials.title}
          </h2>
          <div className="w-24 h-1.5 bg-brand-red mx-auto rounded-full" data-id="element-219"></div>
        </div>

        <motion.div ref={ref} variants={containerVariants} initial="hidden" animate={controls} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-220">
          {t.testimonials.reviews.map((review, index) => <motion.div key={index} variants={itemVariants} className="bg-gray-50 rounded-2xl p-8 shadow-sm border border-gray-100 relative" data-id="element-221">
              <Quote className="absolute top-6 right-6 w-12 h-12 text-gray-200" data-id="element-222" />

              <div className="flex gap-1 mb-6" data-id="element-223">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-red text-brand-red" data-id="element-224" />)}
              </div>

              <p className="text-gray-700 italic mb-8 relative z-10 leading-relaxed" data-id="element-225">
                "{review.quote}"
              </p>

              <div className="border-t border-gray-200 pt-4" data-id="element-226">
                <p className="font-heading font-bold text-brand-black" data-id="element-227">
                  {review.author}
                </p>
                <p className="text-sm text-gray-500 font-medium" data-id="element-228">
                  {review.location}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}